import { AutocompleteItem } from '@delmonicos/shared-design-system-react/src/components/autocomplete-input/autocomplete-input.component';
import { useMemo, useState } from 'react';

import {
  useCpmsBoGetNetworkQuery,
  useCpmsBoGetNetworksPaginatedQuery,
} from '@app/core/service/cpms-bo-network.service';

export const useNetworkAutocomplete = (
  customerId: string | undefined,
  selectedNetworkId: string | undefined,
): {
  search: string;
  setSearch: (search: string) => void;
  selectedItem: AutocompleteItem | null;
  autocompleteItems: AutocompleteItem[];
} => {
  const [search, setSearch] = useState<string>('');

  const { data, isSuccess } = useCpmsBoGetNetworksPaginatedQuery(
    {
      offset: 0,
      limit: 10,
      customerId,
      name: search === '' ? undefined : `~${search}`,
    },
    { skip: !customerId },
  );

  // Resolved independently from the paginated search results — the
  // selected network may not be among the first page of matches.
  const { data: selectedNetwork, isSuccess: selectedNetworkIsSuccess } =
    useCpmsBoGetNetworkQuery(selectedNetworkId as string, {
      skip: !selectedNetworkId,
    });

  const selectedItem = useMemo<AutocompleteItem | null>(() => {
    if (!selectedNetworkId || !selectedNetworkIsSuccess) {
      return null;
    }

    return { key: selectedNetwork.id, label: selectedNetwork.name };
  }, [selectedNetworkId, selectedNetwork, selectedNetworkIsSuccess]);

  const autocompleteItems = useMemo<AutocompleteItem[]>(() => {
    if (!isSuccess) {
      return [];
    }

    return data.docs.map(({ id, name }) => ({ key: id, label: name }));
  }, [data, isSuccess]);

  return { search, setSearch, selectedItem, autocompleteItems };
};
